import * as React from 'react'
// @ts-ignore
import styles from './Header.module.scss'
// @ts-ignore
import Navigation from './Navigation/index'

export function Header({ linkComponent }) {
  return (
    <header className={styles.Header}>
      <Navigation linkComponent={linkComponent} />
    </header>
  )
}
